import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Modal, Row, Tab, Tabs } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import ReportUpload from "../report_upload/ReportUpload";

const GetStartDisputely = ({gotoDashboard}) => {
    const navigate = useNavigate();
    const [showLoginModal,setShowLoginModal] = useState(true);
    const [showReportModal,setShowReportModal] = useState(false);
    const [showLoader,setShowLoader] = useState(false);
    const [reportData, setReportData] = useState({
        report_type: "",
        report_content: ""
    });
    const reportDataRef = useRef({
        report_type: "",
        report_content: ""
    })
    const showModels = (type) => {
        let obj = {
            report_type: "",
            report_content: ""  
        }
        setReportData(obj);
        reportDataRef.current = obj;
        if(type==='report'){
            setShowReportModal(true);
        }else{
            setShowLoginModal(true);
        }
    }
    // if(showLoader){
    //     // return (
    //     //     <Loader />
    //     // )
    // }
    return (
        <React.Fragment>
            <Helmet 
                title="Get Started"
            />
            <Container fluid className="p-0">

            </Container>
            <Modal
                show={false}
                backdrop="static"
                keyboard={false}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <h1 className="text-center">Login to your provider</h1>
                    <p className="text-center">Free Professional Credit Repair.... done in seconds..</p>
                    <Row>
                        <Col><Button size="lg" variant="primary" onClick={()=>showModels('login')}>I have logins</Button></Col>
                        <Col><Button size="lg" variant="primary" onClick={()=>showModels('report')}>I have reports</Button></Col>
                    </Row>
                    <Row className="text-center">
                        <p className="text-primary">Don't have access to your report? No worries!</p>
                        <Button variant="secondary" onClick={()=>navigate('/choose-report')} >Get Your Report Here</Button>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal
                show={showLoginModal}
                backdrop="static"
                keyboard={false}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <ReportUpload 
                        setShowLoader = {setShowLoader}
                        isNagative = {true}
                        id={1}
                        reportData = {reportData}
				        setReportData = {setReportData}
				        reportDataRef = {reportDataRef}
                        isLogin={showLoginModal}
                        closeModel={setShowLoginModal}
                        gotoDashboard={gotoDashboard}
                    />
                </Modal.Body>
            </Modal>

            <Modal
                show={showReportModal}
                backdrop="static"
                keyboard={false}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <ReportUpload 
                        setShowLoader = {setShowLoader}
                        isNagative = {true}
                        id={1}
                        reportData = {reportData}
				        setReportData = {setReportData}
				        reportDataRef = {reportDataRef}
                        isLogin={showLoginModal}
                        closeModel={setShowReportModal}
                        gotoDashboard={gotoDashboard}
                    />
                </Modal.Body>
            </Modal>
            
            <Modal
                show={showLoader}
                backdrop="static"
                keyboard={false}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="sm"
            >
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default GetStartDisputely;